import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import {
    fetchingSubscriptions,
    fetchingConsent,
    subscribing,
    updatingNewsletterError,
    updatingNewlySubscribed,
} from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(fetchingSubscriptions.started, state => ({
        ...state,
        subscriptionLoading: true,
    }))
    .case(fetchingSubscriptions.done, (state, { result }) => ({
        ...state,
        subscriptions: result || { daily: false, weekly: false },
        subscriptionLoading: false,
    }))
    .case(fetchingSubscriptions.failed, state => ({
        ...state,
        subscriptionLoading: false,
    }))
    .case(fetchingConsent.started, state => ({
        ...state,
        consentLoading: true,
    }))
    .case(fetchingConsent.done, (state, { result }) => ({
        ...state,
        consentStatus: result.status,
        consentLoading: false,
    }))
    .case(fetchingConsent.failed, state => ({
        ...state,
        consentLoading: false,
    }))
    .case(subscribing.started, state => ({
        ...state,
        subscriptionPending: true,
        error: false,
    }))
    .case(subscribing.done, state => ({
        ...state,
        subscriptionPending: false,
        errorCount: 0,
        error: false,
    }))
    .case(subscribing.failed, state => ({
        ...state,
        subscriptionPending: false,
        errorCount: state.errorCount + 1,
        error: true,
    }))
    .case(updatingNewsletterError, (state, error) => ({
        ...state,
        error,
    }))
    .case(updatingNewlySubscribed, (state, newlySubscribed) => ({
        ...state,
        newlySubscribed,
    }));

export default reducer;
